import { trackEvent } from 'helpers/Analytics';
import { normaliseWorkLocation } from './buildJobPayload';

export const POST_FLOW_EVENTS = {
  STEP_VIEWED: 'post_flow_step_viewed',
  RESUMED: 'post_flow_resumed',
  RESTARTED: 'post_flow_restarted',
  TRUSTSCORE: 'post_flow_trustscore',
  JOB_CREATED: 'post_flow_job_created',
};

/**
 * Location property for post_flow_job_created.
 * Remote jobs report "remote"; otherwise city and country.
 */
export const formatPostFlowLocation = (answers = {}) => {
  const workLocation = normaliseWorkLocation(
    answers.workLocation || answers.work_location
  );
  if (workLocation === 'fully_remote') {
    return 'remote';
  }

  return [answers.city, answers.locationCountry].filter(Boolean).join(', ');
};

export const trackPostFlowStepViewed = (stepName) => {
  if (!stepName) {
    return;
  }
  trackEvent(POST_FLOW_EVENTS.STEP_VIEWED, { stepName });
};

export const trackPostFlowResumed = (stepName) => {
  if (!stepName) {
    return;
  }
  trackEvent(POST_FLOW_EVENTS.RESUMED, { stepName });
};

export const trackPostFlowRestarted = (stepName) => {
  if (!stepName) {
    return;
  }
  trackEvent(POST_FLOW_EVENTS.RESTARTED, { stepName });
};

/**
 * @param {number|string|null|undefined} score
 */
export const trackPostFlowTrustScore = (score) => {
  if (score == null || score === '') {
    return;
  }
  trackEvent(POST_FLOW_EVENTS.TRUSTSCORE, { score });
};

export const trackPostFlowJobCreated = (answers = {}) => {
  trackEvent(POST_FLOW_EVENTS.JOB_CREATED, {
    role: answers.role || '',
    location: formatPostFlowLocation(answers),
    skills: answers.skills || '',
  });
};

/**
 * TrustScore is owned by TP-304. Emit when the created brief already
 * carries a score so the event is live as soon as the field exists.
 */
export const readBriefTrustScore = (brief) => {
  if (!brief || typeof brief !== 'object') {
    return null;
  }
  if (brief.trust_score != null && brief.trust_score !== '') {
    return brief.trust_score;
  }
  if (brief.trustscore != null && brief.trustscore !== '') {
    return brief.trustscore;
  }
  return null;
};
